import { createFileRoute } from "@tanstack/react-router";
import { useFlags } from "launchdarkly-react-client-sdk";

import Error404 from "@/components/pages/Error404";
import OnboardingHome from "@/features/onboarding/OnboardingHome";
import BasicLayout from "@/layouts/Basic";

function OnboardingRoute() {
  const flags = useFlags();
  // eslint-disable-next-line ts/no-unsafe-assignment
  const showOldSignUp = flags["pd-show-old-sign-up-flow"];

  // eslint-disable-next-line ts/strict-boolean-expressions
  if (showOldSignUp) {
    return (
      <BasicLayout>
        <Error404 />
      </BasicLayout>
    );
  }

  return (
    <BasicLayout>
      <OnboardingHome />
    </BasicLayout>
  );
}

export const Route = createFileRoute("/_auth-basic/onboarding")({
  component: OnboardingRoute,
});
